import * as React from "react";
import {FormsRow} from "./FormsRow";
import {FormGroup} from "./FormGroup";
import {SpinnerButton} from "shared/controls/SpinnerButton";
import {WpAjaxPost} from "shared/core/ajax/WPAjaxPost";
import {ToastService} from "shared/core/services/ToastService";

export class Forms extends React.Component<FormsProps, FormsState> {
    static defaultProps: Partial<FormsProps> = {};

    constructor(props: FormsProps) {
        super(props);
        this.state = {
            IsBusy:false
        };
    }

    public render() {
        return (
            <div className={'rednao'}>
                <table className={'stockForm'}>
                    {formsVar.Data.map(group=>
                        <FormGroup FormGroup={group}/>
                    )}
                </table>
                <SpinnerButton IsBusy={this.state.IsBusy} OnClick={()=>this.Submit()}>Submit Stock</SpinnerButton>
            </div>
        )
    }

    private async Submit() {
        this.setState({IsBusy:true});
        let result=await WpAjaxPost.Post('stock_form_submit',{Data:formsVar.Data,Design:formsVar.Design})
        this.setState({IsBusy:false});
        if(result!=null)
            ToastService.SendSuccess('Form Submitted');
    }
}


//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------
interface FormsProps {

}

interface FormsState {
    IsBusy:boolean;
}

//#endregion "My Region"